import { useEffect, useCallback } from "react";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";

const LogoutSuccess = () => {
  const navigate = useNavigate();

  const clearAppStorage = useCallback(() => {
    localStorage.clear(); // Wipes all localStorage keys
    sessionStorage.clear();
  }, []);

  useEffect(() => {
    clearAppStorage();

    toast.success("You’ve been logged out.");
    const timeoutId = setTimeout(() => {
      navigate("/", { replace: true });
    }, 500);

    return () => clearTimeout(timeoutId);
  }, [clearAppStorage, navigate]);

  return (
    <div className="w-full h-screen flex items-center justify-center">
      <p>Logging you out...</p>
    </div>
  );
};

export default LogoutSuccess;
